import {styled} from "@mui/material/styles"
import {SimplifiedButton} from "../../../horizontalFilters/facetListBox/components"

export const StandardHFMoreLessButton = styled(SimplifiedButton)`
    && {
        color: ${({theme}) => theme.colours.palette.primary.main};
        background-color: ${({theme}) => theme.colours.utilities.background.paper};
        font-size: 0.875rem;
        font-family: ${({theme}) => `${theme.colours.typography.body3.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => `${theme.colours.typography.body3.fontWeight}`};
        text-transform: ${({theme}) => `${theme.colours.typography.overline.textTransform}`};
    }
`
export default StandardHFMoreLessButton
